import { Injectable } from '@angular/core';
import {Plugin, Cordova, CordovaProperty, CordovaInstance, IonicNativePlugin} from '@ionic-native/core';

@Plugin(
  {
    pluginName: "dspread_pos_plugin",
    plugin: "dspread_pos_plugin",
    pluginRef: "cordova.plugins.dspread_pos_plugin",
    repo: "https://github.com/fullstackmofo/Mpos.git",
    platforms: ["Android", "iOS"]
  }
)

@Injectable()

export class MposProvider {

  @Cordova()
  doTrade(success, error, timeout, amount)
  {

  }

  @Cordova()
  scanQPos2Mode(success, error) {

  }
  @Cordova()
  setCardTradeMode(): Promise<any>
  {
    return;
  }
  @Cordova()
  getQposInfo(success, error) {}

  @Cordova()
  getQposId(success, error) {}

  @Cordova()
  connectBluetoothDevice(success, error, isConnect, bluetoothAddress) { }

  @Cordova()
  printText(success, fail, content){}

  @Cordova()
  getDeviceList(success, error){}

  @Cordova()
  updateEmvApp(success, error){}

  @Cordova()
  updateEmvConfig(success, error) {}

  @Cordova()
  updateIPEK(success,error,ipekgroup, trackksn, trackipek, trackipekCheckvalue, emvksn, emvipek, emvipekCheckvalue, pinksn, pinipek, pinipekCheckvalue) {}


}



// WEBPACK FOOTER //
// ./src/providers/mpos/mpos.ts